export const EMPTY_CELL_VALUE = '—'
export const NOT_AVAILABLE = 'N/A'
